/* eslint-disable */
class CartUpsell extends HTMLElement {
  constructor() {
    super();

    this.cartContainer = document.querySelector('#MiniCart')
    this.upsellDrawer = document.querySelector('[data-cart-upsell-item-drawer-back]');
    this.upsellWrap = document.querySelector('.cart-upsell-wrap');

    this.toggleButton = this.querySelector('[data-upsell-toggle]');
    this.content = this.querySelector('[data-upsell-content]');

    this.limit = this.dataset.limit
    this.count = this.dataset.count

    this.toggleWidget = this.toggleWidget.bind(this);
  }

  connectedCallback() {
    if (this.toggleButton) {
      this.toggleButton.addEventListener('click', this.toggleWidget.bind(this))
    }
    if (this.upsellDrawer) {
      this.upsellDrawer.addEventListener('click', (e) => {
        e.preventDefault();
        this.cartContainer && this.cartContainer.classList.remove('show-upsell-drawer');
      })
    }
    this.randomizeUpsell();
  }

  toggleWidget(e) {
    e.preventDefault();
    const isOpening = !this.classList.contains('opened');
    const placeholder = document.querySelector('#MiniCart .placeholder_upsell');

    if (isOpening) {
      // If sticky (out of view), scroll inline first
      if (this.classList.contains('is-sticky')) {
        this.upsellWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      this.classList.add('opened');
      $(this.content).slideDown(250, () => adjustCartUpsellLayout());
      this.upsellWrap.classList.remove('is-sticky'); // remove sticky while open
      placeholder?.classList.remove('active');

    } else {
      this.classList.remove('opened');
      $(this.content).slideUp(250, () => adjustCartUpsellLayout());

      // Re-evaluate if it should be sticky
      if (!isUpsellInView) {
        this.upsellWrap.classList.add('is-sticky');
        placeholder?.classList.add('active');
      }
    }
  }

  randomizeUpsell() {
    const array = this.randomNumbersArray(parseFloat(this.limit), parseFloat(this.count));
    array.map((index, i) => {
      const $target = $(this).find(`.upsell-item-wrap[data-index="${index}"]`);
      $target.removeClass('hide')
    })

    // $(this.content).css('opacity', 1)
  }

  randomNumbersArray(length = 10, maxVal = 20) {
    let randomVals = [];
    const array = [...Array(maxVal).keys()].map(i => i + 1);
    for(let i = 0; i<maxVal; i++) {
      if (randomVals.length < length) {
        const num = Math.floor(Math.random() * (maxVal - randomVals.length)) - 1;
        const selected = array.splice(num, 1);
        randomVals.push(selected[0])
      }
    }

    return randomVals;
  }
}

if (!customElements.get('component-cart-upsell')) {
  customElements.define('component-cart-upsell', CartUpsell);
}

// Visibility observer
let upsellVisibilityObserver;
let isUpsellInView = null;

function adjustCartUpsellLayout() {
  const cart = document.querySelector('#MiniCart');
  if (!cart) return;

  const inner = cart.querySelector('.ajaxcart__inner');
  const productWrap = cart.querySelector('.ajaxcart__product_wrap');
  const upsellWrap = cart.querySelector('.cart-upsell-wrap');
  const upsellComponent = cart.querySelector('component-cart-upsell');
  const upsellContent = upsellComponent?.querySelector('[data-upsell-content]');

  if (!inner || !productWrap || !upsellWrap || !upsellComponent) return;

  const innerRect = inner.getBoundingClientRect();
  const productRect = productWrap.getBoundingClientRect();
  const upsellRect = upsellWrap.getBoundingClientRect();

  const gap = innerRect.height - (productRect.height + upsellRect.height);
  const fitsExactly =
    Math.abs(innerRect.height - (productRect.height + upsellRect.height)) <= 2;

  const isOpen = upsellComponent.classList.contains('opened');

  if (gap < 0) {
    if (isOpen) {
      return;
    }
    $(upsellContent).hide();
    return;
  }
  // RULE 1 — FEW PRODUCTS (EXACT FIT)
  if (fitsExactly && gap > upsellRect.height) {
    return;
  }
  // RULE 2 — CLOSED → ALWAYS STICKY
  if (!isOpen) {
    return;
  }
  // RULE 3 — OPEN + GAP = 0 → INLINE
  if (gap <= 0) {
    return;
  }
}

let cartUpsellObserver;

function initCartUpsellObserver() {
  const cart = document.querySelector('#MiniCart');
  if (!cart || cartUpsellObserver) return;

  cartUpsellObserver = new MutationObserver(() => {
    requestAnimationFrame(initUpsellVisibilityObserver);
  });

  cartUpsellObserver.observe(cart, {
    childList: true,
    subtree: true
  });

  initUpsellVisibilityObserver();
  bindPlaceholderUpsell();
}

function initUpsellVisibilityObserver() {
  const cart = document.querySelector('#MiniCart');
  if (!cart) return;

  const inner = cart.querySelector('.ajaxcart__inner');
  const upsellWrap = cart.querySelector('.cart-upsell-wrap');
  const placeholder = cart.querySelector('.placeholder_upsell');
  const sentinel = upsellWrap?.querySelector('.cart-upsell-sentinel');

  if (!inner || !upsellWrap || !sentinel || !placeholder) return;

  upsellVisibilityObserver?.disconnect();

  upsellVisibilityObserver = new IntersectionObserver(
    ([entry]) => {
      const inView = entry.isIntersecting;

      if (isUpsellInView !== inView) {
        isUpsellInView = inView;

        if (!inView) {
          // Show placeholder
          placeholder.classList.add('active');
          placeholder.classList.remove('hide');

          // Hide real upsell
          upsellWrap.classList.add('is-sticky');

          // Close real upsell content
          const component = upsellWrap.closest('component-cart-upsell');
          component?.classList.remove('opened');
          $(component?.querySelector('[data-upsell-content]')).hide();
        } else {
          // Hide placeholder
          placeholder.classList.remove('active');
          placeholder.classList.add('hide');
          // Show real upsell
          upsellWrap.classList.remove('is-sticky');
        }
      }
    },
    {
      root: inner,
      threshold: 0.1,
      rootMargin: '0px 0px -10px 0px'
    }
  );

  upsellVisibilityObserver.observe(sentinel);

  // Initial state if out of view
  const sentinelRect = sentinel.getBoundingClientRect();
  const innerRect = inner.getBoundingClientRect();
  if (sentinelRect.bottom < innerRect.top || sentinelRect.top > innerRect.bottom) {
    console.log(`%cUpsell false`, `color:red; font-weight:bold`);
    

    if(isUpsellInView){
      placeholder.classList.remove('active');
      upsellWrap.classList.remove('is-sticky');
    } else {
      placeholder.classList.add('active');
      upsellWrap.classList.add('is-sticky');
    } 

    const component = upsellWrap.closest('component-cart-upsell');
    component?.classList.remove('opened');
    $(component?.querySelector('[data-upsell-content]')).hide();
  }
}

function bindPlaceholderUpsell() {
  const cart = document.querySelector('#MiniCart');
  if (!cart) return;

  const placeholderBtn = cart.querySelector('[data-upsell-toggle-inview]');
  const upsellWrap = cart.querySelector('.cart-upsell-wrap');
  const component = cart.querySelector('component-cart-upsell');
  const content = component?.querySelector('[data-upsell-content]');
  const inner = cart.querySelector('.ajaxcart__inner');

  if (!placeholderBtn || !upsellWrap || !component || !inner) return;

  placeholderBtn.addEventListener('click', (e) => {
    e.preventDefault();

    // 1️⃣ scroll real upsell into view (INLINE)
    upsellWrap.scrollIntoView({
      behavior: 'smooth',
      block: 'end'
    });

    // 2️⃣ open accordion after scroll frame
    requestAnimationFrame(() => {
      component.classList.add('opened');
      $(content).slideDown(250);
      upsellWrap.classList.remove('is-sticky');
    });

    // 3️⃣ deactivate placeholder immediately
    placeholderBtn.closest('.placeholder_upsell')?.classList.remove('active');
  });
}

$('body').on('drawer-opt', () => {
  $.getJSON('/?sections=mini-cart', (cart) => {
    const miniCartHtml = cart['mini-cart'];
    const doc = new DOMParser().parseFromString(miniCartHtml, 'text/html');

    const upsellElem = doc.querySelector('.cart-upsell-wrap');
    if (!upsellElem) return;

    $('#MiniCart .cart-upsell-wrap').replaceWith(upsellElem);
    adjustCartUpsellLayout();
    initCartUpsellObserver();
    initUpsellVisibilityObserver(); // ← MUST run after replace
    bindPlaceholderUpsell();
  });
});

document.addEventListener('cart-updated', () => {
    adjustCartUpsellLayout();
    initCartUpsellObserver();
    initUpsellVisibilityObserver();
    bindPlaceholderUpsell();
});
